import BasicFilters, {
  type DatePickerType
} from '@features/reports/components/monitoringReports/DashboardFilters/BasicFilters'
import {
  type Filter,
  SelectedFilters
} from '@features/reports/components/monitoringReports/DashboardFilters/SelectedFilters'
import type { FilterValues } from '@features/reports/components/monitoringReports/MonitoringReport/MonitoringReport'
import type { Resident, User } from '@lmc/ts-common'
import type { SelectVariant } from '@lmc/ui-kit/src/dataEntry/MultiSelect/MultiSelect'
import { forwardRef, type ReactNode } from 'react'
import { CategoryFilters } from './CategoryFilters'

export type FiltersProps = {
  value: FilterValues
  onChange: (value: FilterValues) => void
  reportingId?: string
  withLoggedBy?: boolean
  hasResidentsFilter?: boolean
  itemsPlaceholder?: string
  itemsCategoryFilter?: string
  includeCustom?: boolean
  children?: ReactNode
  allowClearDateRange?: boolean
  variant?: SelectVariant
  selectedFilters?: Filter
  hasSingleResident?: boolean
  picker?: DatePickerType
  testId?: string
}

export const getName = (item: Resident | User) =>
  `${item.name.first} ${item.name.last}`

export const DashboardFilters = forwardRef<HTMLDivElement, FiltersProps>(
  (
    {
      value,
      onChange,
      reportingId,
      withLoggedBy,
      hasResidentsFilter,
      itemsPlaceholder,
      itemsCategoryFilter,
      includeCustom,
      children,
      allowClearDateRange,
      variant = 'default',
      selectedFilters,
      hasSingleResident,
      picker,
      testId = 'dashboard-filters'
    },
    ref
  ) => {
    const handleInputChange = (newValue: Partial<FilterValues>) => {
      const updatedValue: FilterValues = {
        ...value,
        ...newValue
      }
      onChange(updatedValue)
    }

    return (
      <>
        <BasicFilters
          data-testid={testId}
          value={value}
          onChange={handleInputChange}
          withLoggedBy={withLoggedBy}
          hasResidentsFilter={hasResidentsFilter}
          allowClearDateRange={allowClearDateRange}
          variant={variant}
          hasSingleResident={hasSingleResident}
          picker={picker}
        >
          <CategoryFilters
            data-testid={`${testId}-category`}
            value={value}
            reportingId={reportingId}
            itemsPlaceholder={itemsPlaceholder}
            itemsCategoryFilter={itemsCategoryFilter}
            includeCustom={includeCustom}
            variant={variant}
            onChange={handleInputChange}
          />
          {children}
        </BasicFilters>
        {selectedFilters && (
          <div ref={ref} data-testid={`${testId}-selected-filters`}>
            <SelectedFilters selectedFilters={selectedFilters} />
          </div>
        )}
      </>
    )
  }
)
export default DashboardFilters
